import { LegalPageActionTypes } from '../actions';
import { LegalPageState } from '../initial.state';

export const LegalPageReducer = (state = new LegalPageState(), { type, payload }) => {
  switch (type) {
    case LegalPageActionTypes.GET_ALL_TNC: {
      return {
        ...state,
        allTncList: payload,
      };
    }

    case LegalPageActionTypes.UPDATE_TNC: {
      const tncListCopy = [...state.allTncList, payload];
      return {
        ...state,
        allTncList: tncListCopy,
      };
    }

    default: {
      return state;
    }
  }
};
